import { Seo } from "../seo";

const SECTIONS = [
  {
    h: "What we collect",
    p: "When you submit the quote form, we collect your name, phone number, vehicle or lock details, the service you need, and your message. When you call, text or email us, we receive whatever contact details you share.",
  },
  {
    h: "How we use it",
    p: "We use your information only to respond to your request, provide locksmith services, and communicate about your job. Quote form submissions are stored securely and emailed to Arrow Locksmith so we can call you back.",
  },
  {
    h: "What we never do",
    p: "We never sell, rent or share your personal information with third parties for marketing. We never ask for passwords, card numbers or payment details by email or through this website.",
  },
  {
    h: "Cookies and analytics",
    p: "This website does not use advertising trackers. If analytics are added in future, they will be used only to understand how visitors find and use the site, and this policy will be updated.",
  },
  {
    h: "Your choices",
    p: "You can ask us to correct or delete your information at any time by calling (204) 963-9081 or emailing arrowlocksmith204@gmail.com.",
  },
];

export default function PrivacyPage() {
  return (
    <main className="pt-28 md:pt-36 pb-24">
      <Seo
        title="Privacy Policy | Arrow Locksmith, Winnipeg"
        description="How Arrow Locksmith collects, uses and protects your information when you contact us or request a quote online."
        path="/privacy"
      />
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-400 mb-4">Legal</p>
        <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tighter text-zinc-950">
          Privacy Policy
        </h1>
        <p className="mt-4 text-sm text-zinc-500">Arrow Locksmith — Winnipeg, Manitoba, Canada</p>

        <div className="mt-12 space-y-10">
          {SECTIONS.map((s) => (
            <section key={s.h}>
              <h2 className="font-heading text-xl font-semibold tracking-tight text-zinc-950">{s.h}</h2>
              <p className="mt-3 text-base leading-relaxed text-zinc-600">{s.p}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
